module.exports = __webpack_public_path__ + "img/vietnam.4d463ffc.svg";